import React, { useState } from "react";

const LevelRewardSetting = () => {
  const [numLevels, setNumLevels] = useState(0);
  const [levels, setLevels] = useState([]);

  const handleChange = (e) => {
    const value = parseInt(e.target.value, 10);
    if (!isNaN(value) && value > 0) {
      setNumLevels(value);
      setLevels(
        new Array(value).fill({ reward: 0, direct: 0 }) // Initialize both fields
      );
    } else {
      setNumLevels(0);
      setLevels([]);
    }
  };

  const handleInputChange = (index, field, value) => {
    const newLevels = [...levels];
    newLevels[index] = {
      ...newLevels[index],
      [field]: parseFloat(value) || 0, // Update reward or direct value
    };
    setLevels(newLevels);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const levelIncome = levels.map((item, index) => ({
      level: index + 1,
      reward: item.reward,
      direct: item.direct, // Include direct income
    }));

    try {
      const response = await fetch("https://api.betachainx.com/api/admin/create_level", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ level_income: levelIncome }),
      });

      const data = await response.json();
      console.log("API Response:", data);
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>Level, Reward, and Direct Settings</h2>
      <input
        type="number"
        placeholder="Enter number of levels"
        value={numLevels || ""}
        onChange={handleChange}
        min="1"
      />
      <form onSubmit={handleSubmit}>
        {levels.map((item, index) => (
          <div key={index} style={{ marginBottom: "10px" }}>
            <label>Level {index + 1}:</label>
            <input
              type="number"
              step="0.01"
              placeholder="Reward"
              value={item.reward}
              onChange={(e) => handleInputChange(index, "reward", e.target.value)}
              style={{ marginLeft: "10px", marginRight: "10px" }}
            />
            <input
              type="number"
              step="0.01"
              placeholder="Direct"
              value={item.direct}
              onChange={(e) => handleInputChange(index, "direct", e.target.value)}
            />
          </div>
        ))}
        {numLevels > 0 && <button type="submit">Submit</button>}
      </form>
    </div>
  );
};

export default LevelRewardSetting;
